import type { KeyboardEvent } from 'react';

/**
 * Ctrl+Enter, or Cmd+Enter on a Mac, The caller decides what to do with auto-repeat. Deliberately not F6 or Alt+ArrowLeft, which Outlook uses to
 * switch panes and go back.
 */
export const isSaveShortcut = (event: KeyboardEvent<HTMLElement>) =>
  event.key === 'Enter' &&
  (event.ctrlKey || event.metaKey) &&
  !event.altKey &&
  !event.shiftKey &&
  !event.nativeEvent.isComposing;
